import { LandingPanel } from '@features/landing/shared/ui/components/LandingPanel';
import { LandingSection } from '@features/landing/shared/ui/components/LandingSection';
import { LandingSectionSeparator } from '@features/landing/shared/ui/components/LandingSectionSeparator';
import { GrandPrixUpcomingTournaments } from '@features/landing/grandprix/ui/components/GrandPrixUpcomingTournaments';
import { ParticipationChecklist } from '@features/landing/shared/ui/components/ParticipationChecklist';
import { GrandPrixPrize } from '@features/landing/grandprix/ui/components/GrandPrixPrize';
import { Contacts } from '@features/landing/shared/ui/components/Contacts';
import {
  LINK_GRANDPRIX_TELEGRAM_BLITZ,
  LINK_GRANDPRIX_TELEGRAM_RAPID,
} from '@features/chessrussian/customizations/constants';

const TELEGRAM_CHANNELS = [
  {
    label: 'Телеграм-чат Блиц',
    href: LINK_GRANDPRIX_TELEGRAM_BLITZ,
  },
  {
    label: 'Телеграм-чат Рапид',
    href: LINK_GRANDPRIX_TELEGRAM_RAPID,
  },
];

export function GrandPrixTournamentsSection() {
  return (
    <LandingSection>
      <LandingPanel>
        <GrandPrixUpcomingTournaments />
        <LandingSectionSeparator />
        <ParticipationChecklist />
        <LandingSectionSeparator />
        <GrandPrixPrize />
        <LandingSectionSeparator />
        <Contacts telegramChannels={TELEGRAM_CHANNELS} />
      </LandingPanel>
    </LandingSection>
  );
}
